import { Sizes } from './sizing';

export enum TypographyWeight {
  REGULAR = 400,
  SEMIBOLD = 500,
  BOLD = 600,
  BLACK = 900,
}

export enum TypographyFamily {
  BODY = 'Messina Sans',
  FALLBACK = 'Arial, sans-serif',
  SCORE = 'Impact',
}

export const TypographySettings = {
  h1: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[52],
    size: Sizes[44],
    weight: TypographyWeight.BLACK,
  },
  h2: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[40],
    size: Sizes[34],
    weight: TypographyWeight.BLACK,
  },
  h3: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[32],
    size: Sizes[28],
    weight: TypographyWeight.BLACK,
  },
  h4: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[28],
    size: Sizes[22],
    weight: TypographyWeight.BLACK,
  },
  h5: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[24],
    size: Sizes[18],
    weight: TypographyWeight.SEMIBOLD,
  },
  subhead: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[20],
    size: Sizes[16],
    weight: TypographyWeight.REGULAR,
  },
  'subhead-bold': {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[24],
    size: Sizes[16],
    weight: TypographyWeight.BOLD,
  },
  'subhead-semibold': {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[24],
    size: Sizes[16],
    weight: TypographyWeight.SEMIBOLD,
  },
  body: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[20],
    size: Sizes[14],
    weight: TypographyWeight.REGULAR,
  },
  'body-semibold': {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[20],
    size: Sizes[14],
    weight: TypographyWeight.SEMIBOLD,
  },
  footnote: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[16],
    size: Sizes[12],
    weight: TypographyWeight.REGULAR,
  },
  'footnote-semibold': {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[16],
    size: Sizes[12],
    weight: TypographyWeight.SEMIBOLD,
  },
  'footnote-bold': {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[16],
    size: Sizes[12],
    weight: TypographyWeight.BOLD,
  },
  'subhead-all-caps': {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[16],
    size: Sizes[12],
    weight: TypographyWeight.BOLD,
  },
  legal: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[12],
    size: Sizes[10],
    weight: TypographyWeight.REGULAR,
  },
  button: {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[24],
    size: Sizes[16],
    weight: TypographyWeight.SEMIBOLD,
  },
  'button-tertiary': {
    family: `${TypographyFamily.BODY}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[24],
    size: Sizes[16],
    weight: TypographyWeight.BOLD,
  },
  score: {
    family: `${TypographyFamily.SCORE}, ${TypographyFamily.FALLBACK}`,
    height: Sizes[20],
    size: Sizes[24],
    weight: TypographyWeight.REGULAR,
  },
};

export const font = TypographySettings.body;
